import type { BaseProductFragment } from "../generated/graphql"

export const productInCartCount = (cartItems: {
  [key: string]: { product: BaseProductFragment; quantity: number; fairPrice?: number }
}) => {
  const cartArr = Object.values(cartItems ?? [])
  return cartArr.reduce((acc, c) => {
    if (c.quantity > 0) {
      return acc + c.quantity
    }
    return acc
  }, 0)
}

export const productTypeInCartCount = (
  cartItems: {
    [key: string]: { product: BaseProductFragment; quantity: number; fairPrice?: number }
  },
  productType: BaseProductFragment["productType"],
) => {
  const cartArr = Object.values(cartItems ?? [])
  return cartArr.reduce((acc, cartItem) => {
    if (cartItem.quantity > 0 && cartItem.product.productType === productType) {
      return acc + cartItem.quantity
    }
    return acc
  }, 0)
}

export const calculateSubtotalPrice = (cartItems: {
  [key: string]: { product: BaseProductFragment; quantity: number; fairPrice?: number }
}) => {
  const cartArr = Object.values(cartItems ?? [])

  return cartArr.reduce((acc, c) => {
    if (c.quantity > 0) {
      return (acc += c.quantity * (c.fairPrice ?? c.product.price))
    }
    return acc
  }, 0)
}

const _calculateTotalVAT = (cartItems: {
  [key: string]: { product: BaseProductFragment; quantity: number; fairPrice?: number }
}) => {
  const cartArr = Object.values(cartItems ?? [])

  return cartArr.reduce((acc, c) => {
    if (c.quantity > 0) {
      return (acc += (c.quantity * (c.fairPrice ?? c.product.price) * c.product.vat) / 100)
    }
    return acc
  }, 0)
}
